import { Component, OnInit } from '@angular/core';
import { GetTranslationDto, TranslationProcessDto } from '@models/translation';
import { LanguageService } from '@core/services/languages.service';
import {
  Form,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  template: `
    <div class="dialog-content">
      <div>
        <h2
          class="confirm title header-text heavy-header-text"
          mat-dialog-title
        >
          Select a Language
        </h2>
        <mat-dialog-content>
          <form
            id="languageForm"
            [formGroup]="form"
            (ngSubmit)="onSubmit()"
            class="language-collection"
          >
            <label>
              <input
                type="radio"
                [value]="0"
                [checked]="!selectedLanguage"
                formControlName="selectedLanguage"
                [attr.disabled]="disableOption(null)"
              />
              <img src="assets/img/cartoon-usa-flag.png" alt="English" />
              <span>English</span>
            </label>
            <ng-container *ngFor="let language of languages$ | async">
              <label>
                <input
                  type="radio"
                  [value]="language.id"
                  [checked]="language.id === selectedLanguage?.id"
                  formControlName="selectedLanguage"
                  [attr.disabled]="disableOption(language)"
                />
                <img [src]="language.flag.signedUrl" alt="" />
                <span>{{ language.languageName }}</span>
              </label>
            </ng-container>
          </form>
        </mat-dialog-content>
      </div>
      <mat-dialog-actions class="centered">
        <div class="button-container">
          <button mat-button mat-dialog-close>Cancel</button>
          <button
            type="submit"
            form="languageForm"
            mat-raised-button
            color="primary"
          >
            Submit
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  styleUrls: ['language-dialog.styles.scss'],
})
export class LanguageDialogComponent implements OnInit {
  selectedLanguage: GetTranslationDto = null;
  form: UntypedFormGroup;
  constructor(
    private dialogRef: MatDialogRef<LanguageDialogComponent>,
    private languageService: LanguageService,
    private fb: UntypedFormBuilder,
  ) {}

  get languages$() {
    return this.languageService.getLanguages$();
  }

  get activeLanguage$(): Observable<GetTranslationDto> {
    return this.languageService.activeLanguageAsObs$;
  }

  ngOnInit() {
    this.languageService.getAvailableLanguages().subscribe((languages) => {});
    this.selectedLanguage = this.languageService.activeLanguage;
    this.form = this.fb.group({
      selectedLanguage: new UntypedFormControl(
        this.languageService.activeLanguage.id,
        Validators.required,
      ),
    });

    this.form.valueChanges.subscribe((value) => {
      const selectedLanguage = this.languageService.languages.find(
        (lang) => lang.id === value.selectedLanguage,
      );
      if (selectedLanguage) {
        this.selectedLanguage = selectedLanguage;
      } else {
        this.selectedLanguage = null;
      }
    });
  }

  disableOption(language: GetTranslationDto): boolean {
    if (language && this.languageService.activeLanguage?.id === language.id)
      return true;
    if (!this.languageService.activeLanguage.id && !language) return true;
  }

  onSubmit() {
    if (this.form.valid) {
      const { selectedLanguage } = this.form.value;
      const foundLanguage = this.languageService.languages.find(
        (lang) => lang.id === selectedLanguage,
      );
      if (foundLanguage) {
        this.languageService.activeLanguage = foundLanguage;
      } else {
        this.languageService.activeLanguage = new GetTranslationDto();
      }
      this.dialogRef.close(this.languageService.activeLanguage);
    }
  }
}
